import type { Group, User } from "~/client/generated/schema";
import { useGetSearchHistoryQuery } from "~/client/generated/schema";

export type SearchHistoryEntry = Readonly<{
  id: Readonly<string>;
  hasCustomFilterSet: Readonly<boolean>;
  keywords: ReadonlyArray<string>;
  excludeKeywords: ReadonlyArray<string>;
  authorUsers: ReadonlyArray<Partial<User>>;
  groups: ReadonlyArray<Partial<Group>>;
  folders: ReadonlyArray<{
    id: Readonly<string>;
    fullName: Readonly<string>;
    group: Readonly<Partial<Group>>;
  }>;
  dateGte?: Readonly<string | null>;
  isLikedByMe: Readonly<boolean>;
  resourceTypes: ReadonlyArray<string>;
  isArchived: Readonly<boolean>;
}>;

export const useSearchHistory = (): { entries: ReadonlyArray<SearchHistoryEntry>; isLoading: boolean } => {
  const { data, loading } = useGetSearchHistoryQuery({ fetchPolicy: "network-only" });
  return { entries: data?.searchHistory?.entries || [], isLoading: loading };
};
